import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import React from 'react';
export function docletsToMap(doclets) {
  return new Map(doclets.map(function (_ref) {
    var name = _ref.name,
        value = _ref.value;
    return [name, value];
  }));
}
export function getDoclet() {
  var doclets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments.length > 1 ? arguments[1] : undefined;
  var doc = doclets.find(function (d) {
    return d.name === name;
  });
  return doc && doc.value;
}
export function cleanDocletValue(str) {
  return str.trim().replace(/^\{/, '').replace(/\}$/, '');
}
export function getDisplayTypeName(typeName) {
  if (typeName === 'func') return 'function';
  if (typeName === 'bool') return 'boolean';
  return typeName;
}
export function getTypeName(prop) {
  var type = prop.type;
  var name = getDisplayTypeName(type === null || type === void 0 ? void 0 : type.name);
  if (name === 'custom') return cleanDocletValue(getDoclet(prop.tags, 'type') || type.raw);
  return name;
}
export function joinElements(arr, delim, fn) {
  return arr.reduce(function (acc, val, idx, list) {
    var item = fn(val, idx);

    if (React.isValidElement(item)) {
      // eslint-disable-next-line react/no-array-index-key
      item = React.cloneElement(item, {
        key: idx
      });
    } // eslint-disable-next-line no-param-reassign


    acc = acc.concat(item);
    return idx === list.length - 1 ? acc : acc.concat(delim);
  }, []);
}